function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Table, Space } from 'antd';
import { PCircleFill } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ProductsListView = function ProductsListView(_ref) {
  var _ref$productsList = _ref.productsList,
    productsList = _ref$productsList === void 0 ? [] : _ref$productsList;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    productsArrayList = _useState2[0],
    setProductsArrayList = _useState2[1];
  var cols = [{
    title: 'Produit',
    dataIndex: 'label',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: 'Prix (GNF)',
    dataIndex: 'base_price',
    key: 'base_price',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: 'Qte Disponible',
    dataIndex: 'available_quantity',
    responsive: ['lg', 'md', 'sm'],
    key: 'available_quantity',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: 'Stock Min.',
    dataIndex: 'minimum_stock',
    responsive: ['lg', 'md', 'sm'],
    key: 'minimum_stock',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: 'Catégorie.',
    dataIndex: 'category',
    key: 'category',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text == 0 ? "Carburant" : "Produits dérivés"
      });
    }
  }];
  useEffect(function () {
    setProductsArrayList([]);
    productsList.forEach(function (p) {
      setProductsArrayList(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: p.id,
          label: p.label,
          base_price: p.base_price,
          available_quantity: p.available_quantity,
          minimum_stock: p.minimum_stock,
          category: p.category
        }]);
      });
    });
  }, [productsList]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      children: [/*#__PURE__*/_jsx(PCircleFill, {
        size: 45
      }), /*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx("b", {
          children: "PRODUITS"
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
      columns: cols,
      dataSource: productsArrayList,
      pagination: false
    })]
  });
};
export default ProductsListView;